import styled from 'styled-components';

export const TitleContainer = styled.div`
  margin-bottom: 4px;
`;
